import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
export function SectionLabel({
  children,
  className,
  as: Element = "div"
}: {
  children: ReactNode;
  className?: string;
  as?: "div" | "h2" | "h3";
}) {
  return <Element className={cn("text-footnote font-normal text-ink-3", className)} data-sentry-element="Element" data-sentry-component="SectionLabel" data-sentry-source-file="SectionLabel.tsx">
            {children}
        </Element>;
}
export function Keycap({
  children,
  className
}: {
  children: ReactNode;
  className?: string;
}) {
  return <kbd className={cn("rounded-small bg-offwhite-2 px-1.5 py-0.5 font-mono text-caption text-ink-2 shadow-hairline touch:!hidden", className)} data-sentry-component="Keycap" data-sentry-source-file="SectionLabel.tsx">
            {children}
        </kbd>;
}